__turbopack_context__.v({
  "answer": "eventFaq-module__cBXaVa__answer",
  "badge": "eventFaq-module__cBXaVa__badge",
  "clearButton": "eventFaq-module__cBXaVa__clearButton",
  "countBadge": "eventFaq-module__cBXaVa__countBadge",
  "emptyState": "eventFaq-module__cBXaVa__emptyState",
  "emptyText": "eventFaq-module__cBXaVa__emptyText",
  "eventFaq": "eventFaq-module__cBXaVa__eventFaq",
  "expandIcon": "eventFaq-module__cBXaVa__expandIcon",
  "fadeIn": "eventFaq-module__cBXaVa__fadeIn",
  "faqBody": "eventFaq-module__cBXaVa__faqBody",
  "faqCard": "eventFaq-module__cBXaVa__faqCard",
  "faqCardActive": "eventFaq-module__cBXaVa__faqCardActive",
  "faqGrid": "eventFaq-module__cBXaVa__faqGrid",
  "faqHeader": "eventFaq-module__cBXaVa__faqHeader",
  "headerSection": "eventFaq-module__cBXaVa__headerSection",
  "question": "eventFaq-module__cBXaVa__question",
  "resetButton": "eventFaq-module__cBXaVa__resetButton",
  "searchContainer": "eventFaq-module__cBXaVa__searchContainer",
  "searchIcon": "eventFaq-module__cBXaVa__searchIcon",
  "searchInput": "eventFaq-module__cBXaVa__searchInput",
  "searchStats": "eventFaq-module__cBXaVa__searchStats",
  "searchWrapper": "eventFaq-module__cBXaVa__searchWrapper",
  "sectionTitle": "eventFaq-module__cBXaVa__sectionTitle",
  "titleRow": "eventFaq-module__cBXaVa__titleRow",
  "titleWrap": "eventFaq-module__cBXaVa__titleWrap",
  "toggleButton": "eventFaq-module__cBXaVa__toggleButton",
  "toggleWrapper": "eventFaq-module__cBXaVa__toggleWrapper",
});
